<template>
  <div>
    <ReportInfoComp />
  </div>
</template>

<script>
import ReportInfoComp from '@/components/Gl/Investments/Reports/ReportInfoComp.vue';

export default {
  name: 'InveReport',
  components: {
    ReportInfoComp,
  },
};

</script>
